import { $API } from "boot/api";

export function saveContactForNavigation({ commit }, contact) {
  console.log("Saving contact for navigation:", contact);
  commit("SET_CURRENT_CONTACT", contact);
}

export function clearContactData({ commit }) {
  commit("CLEAR_CURRENT_CONTACT");
}

export function fetchContactById({ commit, state }, id) {
  // First check if we already have this contact in store
  if (
    state.currentContactData &&
    state.currentContactData.customernumber === id
  ) {
    return Promise.resolve(state.currentContactData);
  }

  // Otherwise fetch from API
  return $API.CURRENT_COMPANY.GET("customers").then(({ data }) => {
    if (!data || !data.customers || !data.customers.length) {
      throw new Error("No customers data received from API");
    }

    const contact = data.customers.find(
      (c) =>
        c.customer_number === id ||
        c.customer_number.replace(/-/g, "") === id.replace(/-/g, "")
    );
    console.log("Fetched contact data:", contact);
    if (!contact) {
      throw new Error("Contact not found");
    }
    const contactData = {
      id: contact?.id || null,
      customername: contact.customer_name,
      customernumber: contact.customer_number,
      address: contact.address || "N/A",
      industry: contact.industry || "Cannabis",
      status: contact.status || "Active",
      in_greenlists: !!contact.in_greenlists,
      lastOrderDate:
        contact.last_delivery_date || contact.last_order_date || null,
      company: contact.company || { id: null },
      license: contact.license || null,
      contact: null,
      default_sales_rep: contact.default_sales_rep || null,
      default_payment_term: contact.default_payment_term || null,
    };

    commit("SET_CURRENT_CONTACT", contactData);
    return contactData;
  });
}
